import React from 'react';

import { Select, SelectOption } from '@flixbus/honeycomb-react';

import { RECONCILIATION_STATUS } from 'pages/WorkAssignments/WorkAssignmentsStore';

const ReconciliationStatusFilter = ({
	value = RECONCILIATION_STATUS.all,
	onChange = () => {},
	label = 'Reconciliation status',
	placeholder = 'Select status',
	extraClasses = '',
}) => {
	const handleChange = (event) => {
		const nextValue = event?.target?.value ?? '';

		if (nextValue === '') {
			onChange(RECONCILIATION_STATUS.all);
			return;
		}

		const nextStatus =
			Object.values(RECONCILIATION_STATUS).find((option) => option.value === nextValue) ??
			RECONCILIATION_STATUS.all;

		onChange(nextStatus);
	};

	return (
		<Select
			id="reconciliation-status"
			label={label}
			placeholder={placeholder}
			value={value?.value ?? ''}
			onChange={handleChange}
			extraClasses={extraClasses}
		>
			{Object.entries(RECONCILIATION_STATUS).map(([key, option]) => (
				<SelectOption key={key} value={option.value ?? ''}>
					{option.label}
				</SelectOption>
			))}
		</Select>
	);
};

export default ReconciliationStatusFilter;
